// extracted by mini-css-extract-plugin
export var root = "Footer-module--root--OI4fv";
export var social = "Footer-module--social--biEbT";